import React, { ReactElement, useState, useEffect } from "react";
import "./Avatar.css";
import DefaultAvatar from "../../assets/img/logo-reverse-big.svg";

interface Props {
    src: string | undefined;
    variant?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl";
    className?: string;
    isCircle?: boolean;
    defaultIcon?: ReactElement;
}

export default function Avatar({
    src, variant, className, isCircle, defaultIcon,
}: Props): ReactElement {
    const [image, setImage] = useState(src);
    const [shouldShowDefault, setShouldShowDefault] = useState(false);
    useEffect(() => {
        setShouldShowDefault(src == null);
        setImage(src);
    }, [src]);

    const handleError = () => {
        setShouldShowDefault(true);
        setImage(DefaultAvatar);
    };
    if (shouldShowDefault && defaultIcon) {
        return defaultIcon;
    }

    return (

        <img
            alt="User profile"
            src={image ?? DefaultAvatar}
            onError={handleError}
            className={` avatar-${variant} ${className} ${isCircle ? "rounded-circle" : "rounded"}`}
        />
    );
}

Avatar.defaultProps = {
    variant: "md",
    className: "me-2",
    isCircle: true,
    defaultIcon: undefined,
};
